import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import ReferralHash from "../../../common/referral-hash";

import parlor from "assets/graphics/icons/parlor.svg";
import parlorSocialClub from "assets/graphics/icons/parlor-social-club.svg";
import parlorSocialCLubDeskop from "assets/graphics/icons/parlor-social-club-black.svg";

import "features/new/navigation/view.scss";

const NavigationView = ({ shouldNavigationBarVisible }) => (
  <nav className="header__navigation">
    <ul
      className="navigation__bar"
      style={{
        transform: shouldNavigationBarVisible
          ? "translateY(0)"
          : "translateY(-100%)",
      }}
    >
      <li>
        <a
          className="mobile__logo"
          href={
            "#" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          }
        >
          <img src={parlor} alt="parlor" />
        </a>
        <a
          className="deskop__logo"
          href={
            "#" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          }
        >
          <img src={parlorSocialCLubDeskop} alt="parlor social club" />
        </a>
      </li>
      <li className="navigation__download">
        <Link
          to={
            "/application/sign-up" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          }
          onClick={() => {
            window.dataLayer.push({
              event: "applicationVisitedfromNavigation",
            });
          }}
        >
          Request Invite
        </Link>
      </li>
    </ul>
    <ul className="navigation__list">
      <li className="navigation__item--join">
        <Link
          className="navigation__link"
          to={
            "/application/sign-up" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          }
          onClick={() => {
            window.dataLayer.push({
              event: "applicationVisitedfromNavigation",
            });
          }}
        >
          Become a member
        </Link>
      </li>
      <li className="navigation__item--logo">
        <a className="navigation__link" href="#">
          <img
            className="navigation__icon"
            src={parlorSocialClub}
            alt="parlor social club"
          />
        </a>
      </li>
      <li className="navigation__item--anchors">
        <a
          className="navigation__link"
          href="#portal"
          onClick={() => {
            window.dataLayer.push({ event: "mobileApplicationSaw" }); // eslint-disable-line
          }}
        >
          APP Download
        </a>
      </li>
    </ul>
  </nav>
);

NavigationView.propTypes = {
  shouldNavigationBarVisible: PropTypes.bool,
};

export default NavigationView;
